<style lang="scss">
.file-list-item {
    position: relative;
    transition: opacity 0.2s;

    &.deleted {
        opacity: 0.4;
    }

    :global(.close) {
        position: absolute;
        top: -13px;
        right: -13px;
        z-index: 1;
        opacity: 0;
        transition: opacity 0.2s;
    }

    &:hover :global(.close) {
        opacity: 1;
    }

    :global(.progress) {
        position: absolute !important;
        left: 50%;
        top: 50%;
        margin: -16px;
    }
}

img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    display: block;
    border-radius: 5px;
}
</style>
<script lang="ts">
import { createEventDispatcher } from 'svelte';
import CloseControl from './CloseControl.svelte';
import Progress from './Progress.svelte';

export let src: string;
export let deleted = false;
export let progress: number | null = null;

const dispatch = createEventDispatcher();
</script>
<div class="file-list-item" class:deleted data-del={deleted}>
    <CloseControl on:click={() => dispatch('delete')} />
    <img {src} alt="">

    {#if progress != null}
        <Progress {progress} spin cancelable on:click={() => dispatch('delete')} />
    {/if}
</div>
